import { render } from "./Marketplace.vue?vue&type=template&id=e958574e&scoped=true"
import script from "./Marketplace.vue?vue&type=script&lang=js"
export * from "./Marketplace.vue?vue&type=script&lang=js"

import "./Marketplace.vue?vue&type=style&index=0&id=e958574e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e958574e"]])

export default __exports__